import { ArrowLeft } from "lucide-react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export const ButtonLinkBack= () => {
  /* States / Hooks
   *******************************************************************************************/
  const navigate = useNavigate();

  /* Render
   *******************************************************************************************/
  return (
    <Button
      variant='dark'
      size='sm'
      onClick={() => {
        navigate(-1)
      }}
    >
      <ArrowLeft size={16} /> <span className='d-none d-md-inline'>Retour</span>
    </Button>
  )
};
